import React from 'react'
import logo from '../../ymca-logo-full.svg'
import { Container, Row, Col } from 'reactstrap'
import './Header.scss'

const Header = (props) => {
  return (
    <Container fluid id="remote-pplss-header">
      <Row className="header">
        <Col className="m-3 mx-auto">
          <div className="m-xl-2 m-1 mx-auto" title="Go to the homepage" rel="home">
            <img src={logo} className="mx-auto d-block" alt="Digital Signature Capture" />
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Header
